// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","slideShare":"slideShare-module__slideShare___1GHRP"};